import BaseComponent from 'foundation/base-component';
import Cookies from 'js-cookie';
import { RANDA_MEMBER, STANDARD, THEONECLUB } from './constants';
import app from '../../../general/js/app';
import { RA_MEMBER_UPDATED_INFO } from '../../../general/js/user/constants';
import { redirectTo } from '../../../general/js/utils';

export default class ForceSignInComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.accountType = this.getAttribute(this.element, 'account-type');
        this.redirectUrl = this.getAttribute(this.element, 'redirect-url');
        this.checkIsUserLoggedIn();
    }

    checkIsUserLoggedIn() {
        const userDataCookie = Cookies.get(app.state.userDataCookieName);
        const raMemberUpdatedInfoCookie = Cookies.get(RA_MEMBER_UPDATED_INFO);

        switch (this.accountType) {
            case RANDA_MEMBER:
                if (this.isUserLoggedIn(userDataCookie)) {
                    if (this.isRandaMemberLoggedIn(userDataCookie, raMemberUpdatedInfoCookie)) {
                        return true;
                    }
                    if (this.redirectUrl === '') {
                        redirectTo(app.state.memberLoginFailedLink);
                        return false;
                    }
                }

                redirectTo(this.redirectUrl === '' ? app.state.memberLoginFailedLink : this.redirectUrl);
                return false;
            case STANDARD:
                return true;
            case THEONECLUB:
                return true;
            default: return false;
        }
    }

    isUserLoggedIn(userDataCookie) {
        if (userDataCookie !== undefined) {
            const userData = JSON.parse(userDataCookie);
            if (userData !== undefined && userData.isSignedIn) {
                return true;
            }
        }

        return false;
    }

    isRandaMemberLoggedIn(userDataCookie, raMemberUpdatedInfoCookie) {
        const userData = JSON.parse(userDataCookie);

        if (userData.isRandaMember !== undefined && userData.isRandaMember) {
            return true;
        }
        if (userData.hasRaMemberId !== undefined && userData.hasRaMemberId) {
            return true;
        }
        if (raMemberUpdatedInfoCookie && raMemberUpdatedInfoCookie === 'true') {
            return true;
        }

        return false;
    }
}
